var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('vue2-datepicker',{attrs:{"type":"date","format":"DD-MM-YYYY","disabled-date":_vm.disabledDate,"min-date":_vm.minSelectableDate,"max-date":_vm.maxDate,"first-day-of-week":1,"time-picker":false,"clearable":false},on:{"change":_vm.onDateChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }